import React from 'react'
import ApplicationSettings from '../Application/ApplicationSettings';

export default function ExternalServicesSettings() {
    return <ApplicationSettings settings_key="external_services" />
}
